import { render, staticRenderFns } from "./niuNiuSetting.vue?vue&type=template&id=41a615db&scoped=true"
import script from "./niuNiuSetting.vue?vue&type=script&lang=js"
export * from "./niuNiuSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a615db",
  null
  
)

export default component.exports